module.exports = __webpack_public_path__ + "img/home_bg_thailand.fe62feeb.jpg";